interface MelonItem {
  id: string;
  size: string;
  tag: string;
  title: string;
  excerpt: string;
  time: string;
  reads: string;
  comments: string;
  image: string;
}

interface MelonCardProps {
  item: MelonItem;
  featured?: boolean;
}

export default function MelonCard({ item, featured = false }: MelonCardProps) {
  if (featured) {
    return (
      <a
        href="#today"
        className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300 lg:col-span-2 lg:row-span-2"
      >
        <div className="relative h-56 w-full shrink-0 overflow-hidden sm:h-64 lg:h-80">
          <img
            src={item.image}
            alt={`${item.title} - 黑料在线今日新瓜`}
            title={`${item.tag} 黑料在线最新消息`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
          />
          <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50">
            <i className="ri-fire-line" />
            {item.tag}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-5 md:p-7">
          <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 md:text-2xl">
            {item.title}
          </h3>
          <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.excerpt}</p>
          <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line text-sm" />
              {item.time}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-eye-line text-sm" />
              {item.reads}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-chat-3-line text-sm" />
              {item.comments}
            </span>
            <span className="ml-auto flex items-center gap-1.5 whitespace-nowrap text-primary-600">
              查看时间线
              <i className="ri-arrow-right-line text-sm" />
            </span>
          </div>
        </div>
      </a>
    );
  }

  return (
    <a
      href="#today"
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-40 w-full shrink-0 overflow-hidden">
        <img
          src={item.image}
          alt={`${item.title} - 黑料在线滚动爆料`}
          title={`${item.tag} 黑料在线今日新瓜`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
        />
        <span className="absolute left-3 top-3 inline-flex items-center rounded-full bg-background-50/95 px-2.5 py-0.5 text-xs font-medium text-foreground-800">
          {item.tag}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {item.title}
        </h3>
        <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-500 md:text-sm">{item.excerpt}</p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line text-sm" />
            {item.time}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-chat-3-line text-sm" />
            {item.comments}
          </span>
        </div>
      </div>
    </a>
  );
}